import React, { useEffect, useState } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
// import Header from 'components/Header/Header';
import Hero from 'components/Hero/Hero';
import Footer from 'components/Footer/Footer';
import Timeout from 'components/Timeout/Timeout';

import GenerateReportsAlt from 'components/GenerateReportsAlt/GenerateReportsAlt';
import PriceGuideAlt from 'components/PriceGuideAlt/PriceGuideAlt';

import qDocPromise from 'config/qDoc';

import styles from './styles';

const App = ({ classes, history }) => {
  const [loading, setLoading] = useState(true); // State to track loading status

  // Function to reset Qlik selections
  const resetQlikSelections = async () => {
    try {
      const qDoc = await qDocPromise;

      console.log('qDoc in App -> ', qDoc);

      qDoc.clearAll();

      const maxMonthYear = await qDoc.evaluateEx('Date(only([Default Date]), \'MMMM YYYY\')');

      const defaultMonthYearField = await qDoc.getField('[Month Year]');
      const defaultCurrencyField = await qDoc.getField('Currency');
      const defaultServiceCurrencyField = await qDoc.getField('Service_Currency');

      // Perform Qlik selections
      await defaultMonthYearField.select(maxMonthYear.qText);
      await defaultCurrencyField.select('USD');
      await defaultServiceCurrencyField.select('USD');
      setLoading(false); // Set loading to false once done
    } catch (error) {
      console.error('Error resetting Qlik selections:', error);
    }
  };

  useEffect(() => {
    // Listen for route changes
    const unlisten = history.listen(() => {
      setLoading(true); // Set loading to true during resets
      resetQlikSelections();
    });

    // Reset selections when the app loads
    resetQlikSelections();

    return () => {
      unlisten();
    };
  }, [history]);

  // Show a loading spinner or placeholder while resetting selections
  // if (loading) {
  //   return (
  //     <div
  //       style={{
  //         width: '100vw',
  //         height: '100vh',
  //         display: 'flex',
  //         justifyContent: 'center',
  //         alignItems: 'center',
  //         fontSize: 24,
  //       }}
  //     >
  //       {' '}
  //     </div>
  //   );
  // }

  // Render the main application once loading is complete
  return (
    <div className={classes.root}>
      <Timeout />
      {/* <Header /> */}
      <Hero />
      <div className={classes.container}>
        {(loading) && (
          <div className={classes.overlay}>
            <div className={classes.loaderIcon} />
          </div>
        )}
        {
          !loading && (
            <Switch>
              <Route exact path="/">
                <Redirect to="/price-guide" />
              </Route>
              {/* <Route exact path="/price-guide" render={() => <PriceGuide />} /> */}
              <Route exact path="/price-guide" render={() => <PriceGuideAlt />} />
              {/* <Route exact path="/generate-reports" render={() => <GenerateReports />} /> */}
              <Route exact path="/generate-reports" render={() => <GenerateReportsAlt />} />
            </Switch>
          )
        }
      </div>
      <Footer />
    </div>
  );
};

App.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(injectSheet(styles)(App));
